/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/role-has-required-aria-props */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
/* eslint-disable arrow-body-style */
/* eslint-disable func-names */
/* eslint-disable no-alert */
// eslint-disable-line no-nested-ternary

import React, { useState, useEffect, useRef } from 'react';
import MenuItem from '@mui/material/MenuItem';
import {
    ListItemText,
    TextField, Button, Box, Badge, Avatar, Typography, IconButton, FormHelperText, InputLabel, Select, FormControl, Grid, Dialog,
    DialogActions, DialogContent, Tooltip,
    Checkbox, CardContent, CircularProgress,
    DialogTitle, Alert, Radio, RadioGroup, FormControlLabel, FormGroup, CardActionArea, Card
} from "@mui/material";
import { v4 as uuidv4 } from 'uuid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom'
import { DropzoneArea } from 'material-ui-dropzone';
import { makeStyles } from '@mui/styles';
import katex from "katex";
import SnackBar from '../../../components/snackbar/snackbar';
import adminServices from '../../../services/adminServices';
import Page from '../../../components/Page'
import PageHeader from '../../../components/PageHeader';
import DialogModal from '../../../components/modal/DialogModal';
import './styles.css'
import "katex/dist/katex.min.css";

window.katex = katex;

const AddClat = () => {
    const userInfo = useSelector((state) => state.userInfo && state.userInfo);
    const navigate = useNavigate();
    const location = useLocation();
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [questionList, setQuestionList] = useState([]);
    const [category, setCategory] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarTitle, setSnackbarTitle] = useState('');
    const [name, setName] = useState('');
    const [questionid, setQuestionid] = useState([]);
    const [questionDetails, setQuestionDetails] = useState('');
    const [questionpassage, setQuestionPassage] = useState('');
    const [complexity, setComplexity] = useState('');
    const [assessmenttype, setAssessmentType] = useState('CLATPASSAGE');
    const [nameError, setNameError] = useState('');
    const [ImageError, setImageError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [ComplexityError, setComplexityError] = useState('');
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [loadingQuestion, setLoadingQuestion] = useState(false);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const [error, setError] = useState(false);
    const [requirederrors, setrequiredErrors] = useState({
        moduleName: "",
        weightageIs: "",
        questionid: "",
    });
    const [nodata, setNodata] = useState(true);
    const [categoryList, setCategoryList] = useState([])
    const [courseList, setCourseList] = useState([])
    const [thumbImage, setThumbImage] = useState(null);
    const [thumbPreview, setThumbPreview] = useState(null);
    const [editorValue, setEditorValue] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [OpenDialogNew, setOpenDialogNew] = useState(false);
    const [visible, setVisible] = useState(true);
    const [editData, setEditData] = useState("");
    const [editIndex, setEditIndex] = useState("");
    const [editIndexnew, setEditIndexnew] = useState("");
    const [shortdescription, setShortDescription] = useState('');
    const [editDialog, setEditDialog] = useState(false);
    const [moduleName, setModuleName] = useState('');
    const [passage, setPassage] = useState('');
    const [passageError, setPassageError] = useState('');
    const [moduleNameError, setModuleNameError] = useState('');
    const [explanation, satExplanation] = useState('');
    const [points, setPoints] = useState('');
    const [questionError, setQuestionError] = useState({
        passage: "",
        question: "",
        option: "",
        Objective: '',
        explanation: ''
    });
    const [open, setOpen] = useState(false);
    const [moduleData, setModuleData] = useState([]);
    console.log(moduleData, "moduleDatamoduleData");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageAll, setErrorMessageAll] = useState("");
    const [selectedOption, setSelectedOption] = useState('create');
    const [selectedSkills, setSelectedSkills] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [isFree, setIsFree] = useState(false);
    const [hasCertificate, setHasCertificate] = useState(false);
    const [Preview, setPreview] = useState(false);
    const [previewData, setPreviewData] = useState('');
    const [details, setDetails] = useState({ level: "", questionType: "Clat" });
    const [detailsError, setDetailsError] = useState({
        level: '',
        questionType: ''
    });
    const [passageList, setPassageList] = useState([]);
    const [selectedPassages, setSelectedPassages] = useState([]);


    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteData, setDeleteData] = useState('');

   const handleDelete = (data, inx) => {
        setDeleteData(data)
        setDeleteOpen(true)
    }
    const handleDeleteClose = () => {
        setDeleteData('')
        setDeleteOpen(false)
    }

    const DeleteModules = async () => {
        if(deleteData.id){
        try {
            const response = await adminServices.deleteSATAssessmentModule(deleteData.id,location.state, deleteData.questions);
            if (response.ok) {
                setSnackbarTitle('Clat Module Deleted successfully');
                setOpenSnackbar(true);
                setTimeout(() => {
                    navigate('/app/CLAT', { state: { comingfrom: 1 } });
                }, 2000);
                setLoading(false);
            }

        } catch (error) {
            setLoading(false);
        }
    }
        else{
        
                setModuleData((prevModules) =>
                  prevModules.filter((module) => module.name !== deleteData.name)
                );
                  setDeleteData('')
            setDeleteOpen(false)
                setSnackbarTitle('Clat Module Deleted successfully');
                setOpenSnackbar(true);
              
        }
    }

    useEffect(() => {
        getPassageList(assessmenttype);
    }, [assessmenttype])

    const getPassageList = async (type) => {
        const search = ''
        try {
            const result = await adminServices.getPassage(0, 1000, type, search);
            if (result.ok) {
                setPassageList(result.data.data);
            }
        } catch (error) {
            console.log("Error getting passages:", error);
        }
    }

    const handleModuleNameChange = (event) => {
        const selectedModule = event.target.value;
        setModuleName(selectedModule);
        setModuleNameError('')
    };
    const [openPassageDialog, setOpenPassageDialog] = useState(false);
    const [editPassageIndex, setEditPassageIndex] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [assessmentData, setAssessmentData] = useState('');


    const filteredPassages = passageList.filter((p) => p.passage_text?.toLowerCase().includes(searchTerm.toLowerCase()));

    const handleEditPassage = (index, data) => {
        setEditPassageIndex(index);
        setModuleName(data.name);
        setModuleNameError('');

        const selectedIds = data.passages?.map(p => p.id) || [];
        setPassage(selectedIds);

        if (index !== null && index !== undefined && index >= 0) {
            const allSelected = moduleData.filter((m, idx) => idx !== index).flatMap(m => (Array.isArray(m.passages) ? m.passages.map(p => p.id) : []));
            setSelectedPassages(allSelected);
        } else {
            const allSelected = moduleData.flatMap(m => (Array.isArray(m.passages) ? m.passages.map(p => p.id) : []));
            setSelectedPassages(allSelected);
        }

        setOpenPassageDialog(true);
    };


    const handlePreviewOpen = (data) => {
        setPreview(true)
        setPreviewData(data)
    }

    const handleClosePassageDialog = () => {
        setOpenPassageDialog(false);
        setPassage([]);
        setEditPassageIndex(null);
        setModuleName('');
    };

    useEffect(() => {
        if (assessmentData) {
            setName(assessmentData?.title)
            setComplexity(assessmentData?.complexity_level)
            setAssessmentType('CLATPASSAGE')
            setThumbPreview(assessmentData?.image_name);
            setThumbImage(assessmentData?.image_name);
            setEditorValue(assessmentData?.short_description)
            setShortDescription(assessmentData?.highlighted_section)
            setModuleData(assessmentData?.modules)
        }
    }, [assessmentData])

    const handleUpdatePassages = () => {
        if (editPassageIndex === null) return;

        if (!moduleName || moduleName.trim() === '') {
            setModuleNameError('Module name is required');
            return;
        }

        if (!passage || passage.length === 0) {
            setSnackbarTitle('Please select at least 1 passage');
            setOpenSnackbar(true);
            return;
        }

        const updatedModules = [...moduleData];
        updatedModules[editPassageIndex].name = moduleName.trim();
        updatedModules[editPassageIndex].passages = Array.isArray(passage)
            ? passage.map((id) => {
                const found = passageList.find((p) => p.id === id);
                return found ? { id: found.id, passage_text: found?.passage_text } : { id };

            })
            : [];

        setModuleData(updatedModules);
        handleClosePassageDialog();
        setSnackbarTitle('Module updated successfully');
        setOpenSnackbar(true);
    };


    const handleChangeDescription = (value) => {
        const cleanedValue = value
            .replace(/<p><br><\/p>/g, '')
            .replace(/<p><\/p>/g, '')
            .trim();
        setDescriptionError("");
        setEditorValue(cleanedValue);
    };

    const handlePreview = () => {
        setPreview(false)
        setEditIndexnew('')
        setPreviewData('')
    }


    const DeleteQuestion = (index) => {
        setPreviewData((prev) => ({
            ...prev,
            questions_list: prev?.questions_list.filter((_, i) => i !== index),
            questiondetails: prev?.questiondetails.filter((_, i) => i !== index)
        }));
    };

    const handleUpdateQuestions = (editIndexnew) => {
        setModuleData((prevModuleData) =>
            prevModuleData.map((item, index) =>
                index === editIndexnew ? { ...item, ...previewData } : item
            )
        );
        setPreview(false);
    };


    useEffect(() => {
        const fetchNEETDetails = async () => {
            if (location.state) {
                setError(null);
                try {
                    const details = await adminServices.getAllAssessmentDetailsById(location.state);
                    if (details && details.data) {
                        setAssessmentData(details.data?.assessmentData);
                    } else {
                        setError(new Error("Failed to load NEET details: No data or invalid structure."));
                        setAssessmentData({});
                    }
                } catch (err) {
                    setError(new Error(err.message || "An error occurred while fetching NEET details."));
                    console.error("Error fetching NEET details:", err);
                    setAssessmentData({});
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(false);
                setError(new Error("No assessment ID provided in navigation state."));
            }
        };

        fetchNEETDetails();
    }, [location.state]);

    useEffect(() => {
        getCategory()
        setLoading(false);
        setLoadingQuestion(true)
        getQuestionList(details.questionType, search);
    }, [details.questionType, search]);


    useEffect(() => {
        if (category) {
            getCourse(category)
        }
    }, [category])




    const getCourse = async (category) => {
        const result = await adminServices.getCourseBasedOnId(category);
        if (result.ok) {
            setCourseList(result.data)
        }
    }



    const getQuestionList = async (data, search) => {

        const result = await adminServices.getSatQuestion(data, search, page)
        setQuestionList(result.data)
        setLoadingQuestion(false)
        if (result.ok) {
            if (result.data?.length === 0) {
                setNodata(true)
            }
            else {
                setNodata(false)
            }
        }
    };

    const handleFileChange = (file) => {
        setImageError("")
        if (file[0]?.size < 2097152) {
            imageWidthAndHeight(file[0]).then((res) => {
                if (res.width >= 360 && res.height >= 200) {
                    const url = URL.createObjectURL(file[0]);
                    setThumbPreview(url);
                    setThumbImage(file[0]);
                } else {
                    alert("Image dimensions must be at least 360x200px.");
                }
            });
        }
    };

    const imageWidthAndHeight = (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = function () {
                img.onload = function () {
                    resolve({ width: img.width, height: img.height });
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(file);
        });
    };

    const getCategory = async () => {
        const result = await adminServices.getCategoryLists();
        if (result.ok) {
            setCategoryList(result.data)
        }
    };

    const Validation = () => {

        if (!name) {
            setNameError("Name field is required")
            return false
        }

        if (!complexity) {
            setComplexityError("Level field is required")
            return false
        }

        if (!thumbImage) {
            setImageError("Thumb Image field is required")
            return false
        }
        if (!editorValue) {
            setDescriptionError("Description field is required")
            return false
        }
        if (editorValue?.length > 255) {
            setDescriptionError("Description cannot be more than 255 characters");
            return false;
        }

        if (moduleData?.length === 0) {
            setErrorMessage("Please add atleast one module");
            return false
        }



        return true
    }

    const handleSubmit = async () => {
        const valid = Validation()

        if (valid) {
            if (location?.state === null) {
                setLoading(true);

                const totalSeconds = (time.hours * 3600) + (time.minutes * 60) + time.seconds;
                const selectedQuestions = moduleData && moduleData?.map(module => module.questions_list).flat()
                moduleData.forEach((data) => {
                    delete data.passage_text;
                });
                const formData = new FormData();
                formData.append('name', name);
                formData.append('complexity_level', complexity);
                formData.append('description', editorValue);
                // formData.append('time_in_mins', totalSeconds);
                formData.append('time_in_mins', 7920);
                formData.append('thumbImage', thumbImage);
                formData.append('modules', JSON.stringify(moduleData));
                formData.append('userId', userInfo.id);
                formData.append('is_free', isFree);
                formData.append('hasCertificate', hasCertificate);
                formData.append("short_description", shortdescription);
                formData.append("assessment_type_id", "UG Test");

                try {
                    const response = await adminServices.ClatCreation(formData);
                    if (response.ok) {
                        setSnackbarTitle('Clat created successfully');
                        setOpenSnackbar(true);
                        navigate('/app/CLAT', { state: { comingfrom: 1 } });
                        CloseFunction()
                        setModuleData([])
                        setName('')
                        setLoading(false);
                    }

                } catch (error) {
                    console.log(error);
                }
            }
            else {
                setLoading(true);
                const formData = new FormData();
                formData.append('id', location?.state);
                formData.append('name', name);
                formData.append('complexity_level', complexity);
                formData.append('description', editorValue);
                formData.append('thumbImage', thumbImage);
                formData.append('userId', userInfo.id);
                formData.append('is_free', isFree);
                formData.append('hasCertificate', hasCertificate);
                formData.append("short_description", shortdescription);


                try {
                    const response = await adminServices.ClatUpdate(formData);
                    if (response.ok) {
                        setSnackbarTitle('Clat Updated successfully');
                        setOpenSnackbar(true);
                        navigate('/app/CLAT', { state: { comingfrom: 1 } });
                        CloseFunction()
                        setModuleData([])
                        setName('')
                        setLoading(false);
                    }

                } catch (error) {
                    console.log(error);
                }
            }

        }

    };

    const CloseFunction = () => {
        setComplexity("")
        setCategory("")
        setName("")
        setEditorValue("")
        // setQuestionList([])
        setNameError("")
        setComplexityError("")
        setImageError("")
        setDescriptionError("")
        setThumbPreview(null)
        setThumbImage(null)
        setQuestionError({
            passage: "",
            question: "",
            option: "",
            Objective: '',
            explanation: ''


        });
        setDetails({
            level: "",
            questionType: "Clat",
        })
        setrequiredErrors({
            moduleName: "",
            weightageIs: "",
            questionid: "",
            level: "",
        });
    }

    const [time, setTime] = useState({
        hours: 0,
        minutes: 0,
        seconds: 0,
    });


    const handleDialogOpen = (data) => {
        setErrorMessageAll("")
        // if (!name || !complexity || !editorValue) {
        //     setErrorMessageAll("Please fill out the Above Details.");
        // } else {
        setDetails(prevDetails => ({
            ...prevDetails,
            questionType: data
        }));
        setOpen(true);
        // }

        setModuleName('');
        setModuleNameError('');
        setPassage([]);
        setPassageError('');

        const allSelected = moduleData.flatMap(m =>
            (Array.isArray(m.passages) ? m.passages.map(p => p.id) : [])
        );
        setSelectedPassages(allSelected);

        setOpen(true);
    };









    const handleClose = () => {
        setPage(0)
        setModuleName('');
        // setWeightage("")
        setSubmitted(false);
        setQuestionid('')
        setSelectedQuestions([])
        setQuestionDetails('')
        setQuestionPassage('')
        setVisible(true);
        setSelectedOption('create')
        setDetails({ level: "", questionType: "Clat" });
        setSelectedSkills("")
        setPassage("")
        satExplanation('');
        setSelectedSkills("");
        setOpen(false);
        setQuestionError({
            passage: "",
            question: "",
            option: "",
            Objective: '',
            explanation: ''
        });
        setDetails({
            level: "",
            questionType: "Clat",
        })
        setrequiredErrors({
            moduleName: "",
            weightageIs: "",
            questionid: "",
            level: "",
        });
    };

    const handleCloseEdit = () => {
        setPage(0)
        setEditDialog(false);
        setEditData("")
        setEditIndex("")
    };

    const EditModule = (e) => {
        const { name, value } = e.target;
        setEditData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleModuleUpdateQuestion = () => {
        const updatedModules = [...moduleData];
        updatedModules[editIndex] = editData;
        setModuleData(updatedModules);
        setEditDialog(false);
    };

    const QuestionValidation = () => {
        const requirederrors = { moduleName: "", weightageIs: "", questionid: "" };
        const tempDetailsError = { level: '' };
        // let isValid = true;

        if (!moduleName && questionid.length === 0 && !selectedSkills && !details.level) {
            setrequiredErrors({ moduleName: "Name is required!", questionid: "Please Submit question and Answer!" })
            setQuestionError({ Objective: "Please Select Level of Objective" });
            setDetailsError({ level: 'Please select a level' });
        }
        if (!selectedSkills) {
            setQuestionError({ Objective: "Please Select Level of Objective" });
            return false;
        }
        if (!moduleName) {
            requirederrors.moduleName = "Module Name is required!";
            return false;
        }
        // if (!points) {
        //     requirederrors.points = "Module Weightage is required!";
        // }
        if (parseInt(points, 10) === '0' || parseInt(points, 10) === 0 || parseInt(points, 10) < 1) {
            requirederrors.points = "Value cannot be 0";
        }
        if (!questionid) {
            requirederrors.questionid = "Please Submit question and Answer!";

        }
        if (questionid?.length === 0) {
            requirederrors.questionid = "Please Submit question and Answer!";
        }

        // if (!details.level) {
        //     tempDetailsError.level = 'Please select a level';
        //     isValid = false;
        // }


        setDetailsError(tempDetailsError);

        setrequiredErrors(requirederrors);
        return Object.values(requirederrors).every((error) => error === "");
    };

    const ClatModuleValidation = () => {
        if (!moduleName) {
            setModuleNameError("Please select Module Name ");
            return false
        }
        if (!passage || passage.length === 0) {
            setPassageError("Please select atleast one Passage");
            return false
        }
        return true
    }


    const handleModuleSubmitCreate = () => {
        const Validation = ClatModuleValidation();

        if (Validation) {
            const newFormObject = {
                name: moduleName,
                passages: Array.isArray(passage)
                    ? passage.map((id) => {
                        const found = passageList.find((p) => p.id === id);
                        return found ? { id: found.id, passage_text: found?.passage_text } : { id };
                    })
                    : [],
            };

            setModuleData([...moduleData, newFormObject]);

            // Reset all states
            setModuleName("");
            setErrorMessage("");
            setPoints("");
            setQuestionid([]);
            setSubmitted(false);
            setVisible(true);
            setQuestionDetails("");
            setQuestionPassage();
            setSelectedQuestions([]);
            setPage(0);
            setSelectedOption("create");
            setDetails({ level: "", questionType: "Clat" });
            setSelectedSkills("");
            setPage(0);
            setPassage([]);
            setSelectedSkills("");
            handleClose();
        }
    };



    const UpdateModules = async (data, index) => {
        try {
            const response = await adminServices.updateClatAssessmentModule(data.id, data, userInfo.id, location.state);
            if (response.ok) {
                setSnackbarTitle(data.id ? 'Clat Module updated successfully' : 'Clat Module Created successfully');
                setOpenSnackbar(true);
                setTimeout(() => {
                    navigate('/app/CLAT', { state: { comingfrom: 1 } });
                }, 2000);
                setLoading(false);
            }

        } catch (error) {
            setLoading(false);
        }
    }


    return (
        <>
            <Page title={location?.state === null ? "Add Assessment" : "Edit Assessment"}>
                <PageHeader pageTitle={location?.state === null ? "Add Assessment" : "Edit Assessment"} />
                <Grid container spacing={2} className='GACognitivesection' sx={{ mb: 2, padding: '15px 20px' }}>
                    <Grid item xs={12} sm={3} sx={{ marginBottom: '18px', paddingRight: '18px' }}>
                        <TextField
                            variant="outlined"
                            inputProps={{ maxLength: 50 }}
                            fullWidth
                            id="addname"
                            label="Name *"
                            type="search"
                            value={name}
                            onChange={(e) => { setName(e.target.value); setNameError(''); }}
                            sx={{
                                // bgcolor: "#f0f0f0",
                                borderRadius: 1,
                                height: 36,
                                '& .MuiInputBase-input': {
                                    fontSize: 14,
                                    padding: "8px 12px",

                                },
                            }}
                            error={!!nameError}
                        />
                        {nameError && <FormHelperText error>{nameError}</FormHelperText>}
                    </Grid>

                    <Grid item xs={12} sm={3} sx={{ marginBottom: '15px', paddingRight: '18px' }}>
                        <FormControl fullWidth variant="outlined" sx={{
                            // bgcolor: "#f0f0f0", 
                            borderRadius: 1
                        }}>
                            <InputLabel id="complexity-level-label">Difficulty Level *</InputLabel>
                            <Select
                                labelId="complexity-level-label"
                                id="addnamecomplexity"
                                value={complexity || ""}
                                onChange={(e) => { setComplexity(e.target.value); setComplexityError("") }}
                                label="Difficulty Level"
                                error={!!ComplexityError}
                                sx={{
                                    // height: 36,
                                    '& .MuiSelect-select': {
                                        // fontSize: 14,
                                        padding: "8px 12px",

                                    },
                                }}
                            >
                                <MenuItem value="">Select Complexity</MenuItem>
                                <MenuItem value="easy">Beginner</MenuItem>
                                <MenuItem value="medium">Intermediate</MenuItem>
                                <MenuItem value="hard">Advanced</MenuItem>
                            </Select>
                            {ComplexityError && <FormHelperText error>{ComplexityError}</FormHelperText>}
                        </FormControl>
                    </Grid>


                    <Grid item xs={12} sm={6} sx={{ marginBottom: '15px', paddingRight: '18px' }}>
                        <Grid container className='AssessmentTime' spacing={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="complexity-level-label">Assessment Type</InputLabel>
                                    <Select
                                        labelId="complexity-level-label"
                                        id="addassessmenttype"
                                        value={assessmenttype || ""}
                                        onChange={(e) => {
                                            const selectedType = e.target.value;
                                            setAssessmentType(selectedType);
                                        }}
                                        label="Assessment Type"
                                        sx={{
                                            // height: 36,
                                            '& .MuiSelect-select': {
                                                // fontSize: 14,
                                                padding: "8px 12px",

                                            },
                                        }}
                                        disabled
                                    >
                                        <MenuItem value="CLATPASSAGE">CLAT</MenuItem>
                                        {/* <MenuItem value="JEEPASSAGE">JEE</MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid className="unique" item xs={12} sm={6} sx={{ marginBottom: '0px', paddingRight: '18px' }}>
                        {thumbPreview === null ? (
                            <FormControl style={{ height: '100%' }}
                                required
                                component="fieldset"
                                color="primary"
                                variant="outlined"
                                fullWidth
                                name="thumbImage"
                            >
                                <Typography variant="subtitle1">Thumb Image* <span style={{
                                    fontSize: '12px',
                                    float: 'inline-end', paddingBottom: '0', marginBottom: '0', position: 'relative', top: '5px'
                                }}>required resolution (360X200)</span></Typography>
                                <DropzoneArea className="dropTextArea"
                                    acceptedFiles={['image/jpeg', 'image/png', 'image/bmp']}
                                    showPreviews={false}
                                    dropzoneText="Drag and Drop Image or Browse File"
                                    showPreviewsInDropzone={false}
                                    maxFileSize={300000000}
                                    filesLimit={1}
                                    showAlerts={false}
                                    styles={{
                                        height: '100%', minHeight: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center'
                                    }}
                                    onChange={handleFileChange}
                                    useChipsForPreview
                                    previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                                    showFileNamesInPreview
                                />
                                {ImageError && <FormHelperText error>{ImageError}</FormHelperText>}
                            </FormControl>


                        ) : (
                            <div className={classes.imgPreviewRoot}>
                                <Typography variant="subtitle1">Thumb Image</Typography>
                                <Badge
                                    badgeContent={
                                        <CloseIcon id='ThumbPreview'
                                            className={classes.badgeAlign}
                                            onClick={() => {
                                                setThumbPreview(null);
                                                setThumbImage(null);
                                            }}
                                        />
                                    }
                                >
                                    <Avatar
                                        variant="rounded"
                                        src={thumbPreview}
                                        style={{ minHeight: '150px !important' }}
                                        className={thumbPreview !== null && classes.fileImgSIze}
                                    />
                                </Badge>
                            </div>
                        )}
                    </Grid>


                    <Grid item xs={12} sm={6} sx={{ marginBottom: '15px', paddingRight: '18px' }}>
                        <Typography sx={{display:'flex' , flexDirection:'row'}} variant="subtitle1">Description *   
                             {descriptionError && <FormHelperText error>{descriptionError}</FormHelperText>}
                        </Typography>
                       
                        <ReactQuill
                            theme="snow"
                            id='questionText'
                            name="question"
                            value={editorValue}
                            onChange={(content) => {
                                if (content.length > 255) {
                                    handleChangeDescription(content.slice(0, 255));
                                } else {
                                    handleChangeDescription(content);
                                }
                            }}
                            onPaste={(e) => {
                                e.preventDefault();
                                const clipboardText = e.clipboardData.getData('text').slice(0, 255);
                                handleChangeDescription(clipboardText);
                            }}
                            // fullWidth
                            style={{ height: '150px', marginBottom: '30px' }}
                        />

                    </Grid>

                    <Grid item xs={6}>
                        <Typography className={classes.background} gutterBottom variant="subtitle1">
                            Short Description
                        </Typography>
                        <Box>
                            <textarea
                                id="shortdescription"
                                value={shortdescription}
                                onChange={(event) => setShortDescription(event.target.value)}
                                placeholder="Enter shortdescription"
                                rows="5"
                                cols="40"
                                maxLength={250}
                                style={{
                                    width: "100%",
                                    height: "150px",
                                    padding: "10px",
                                    fontSize: "16px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    outline: "none",
                                    resize: "both",
                                    transition: "border-color 0.3s",
                                }}
                            />
                        </Box>
                    </Grid>


                    <Grid item xs={12} md={6} >
                        <span style={{ visibility: 'hidden' }}>Empty</span>
                    </Grid>

                    {moduleData && moduleData.length > 0 && moduleData.map((data, index) => (
                        <Grid container spacing={2} key={index} sx={{ marginBottom: 2 }} style={{ paddingLeft: '15px' }}>
                            <Grid item xs={6} style={{ paddingLeft: '15px' }}>
                                <Card>
                                    <CardActionArea>
                                        <CardContent>
                                            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 1 }} >
                                                <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                                                    {data.name}
                                                </Typography>
                                                <Box display="flex" alignItems="center" gap={1} sx={{ marginLeft: -1 }}>
                                                    <IconButton id="EditPassageIconBtn" onClick={() => handleEditPassage(index, data)} color="error" size="small" >
                                                        <EditIcon id="EditPassageIcon" />
                                                    </IconButton>
                                                    <IconButton id='VisibilityIcon' style={{ height: '40px' }} color="error"
                                                        onClick={() => handlePreviewOpen(data)}
                                                    > < VisibilityIcon /></IconButton>

                                                    {location?.state && (
                                                        data?.id ? <Button id='btnUpdateIs' color="primary"
                                                            onClick={() => UpdateModules(data, index)}
                                                        >Update </Button>
                                                            :
                                                            <Button id='btnUpdateIs' color="primary"
                                                                onClick={() => UpdateModules(data, index)}
                                                            >Create </Button>
                                                    )}
                                                      {/* {location?.state && (
                                                        data?.id && */}
                                                         <Button id='btnUpdateIs' color="primary"
                                                            // onClick={() => DeleteModules(data)}
                                                            onClick={() => handleDelete(data)}
                                                        ><DeleteOutlinedIcon/> </Button>
                                                    {/* )} */}
                                                </Box>
                                            </Box>

                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        </Grid>
                    ))}


                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'end', paddingTop: '15px' }}>
                        <Button id='AddModule' sx={{ marginRight: '15px', paddingBottom: '0px' }} variant="contained" color="primary" onClick={() => handleDialogOpen("Clat")}>
                            Add Module
                        </Button>

                        <Box sx={{ marginRight: '15px' }}>
                            <LoadingButton
                                type="submit"
                                id="addassessmentgeneral"
                                onClick={handleSubmit}
                                variant="contained"
                                color="primary"

                                loading={loading}
                            >
                                {location?.state === null ? 'Submit' : 'Update'}
                            </LoadingButton>
                        </Box>
                    </Grid>
                    {errorMessage && (
                        <Alert severity="error" sx={{ marginBottom: '10px' }}>
                            {errorMessage}
                        </Alert>
                    )}
                    {errorMessageAll && (
                        <Alert severity="error" sx={{ marginBottom: '10px' }}>
                            {errorMessageAll}
                        </Alert>)}
                </Grid>

                <Dialog open={open} onClose={handleClose} fullWidth sx={{ '& .MuiDialog-paper': { maxHeight: '75vh !important', overflow: 'hidden !important' } }}>
                    <DialogTitle style={{ paddingBottom: '0px' }}>Add CLAT Module</DialogTitle>
                    <DialogContent className='GACognitivesection' sx={{ paddingTop: '25px !important' }}>
                        <Box sx={{ marginBottom: '18px' }}>
                            <FormControl fullWidth variant="outlined" sx={{ borderRadius: 1 }}>
                                <TextField
                                    variant="outlined"
                                    inputProps={{ maxLength: 50 }}
                                    fullWidth
                                    id="addname"
                                    label="Module Name *"
                                    type="search"
                                    value={moduleName}
                                    onChange={handleModuleNameChange}
                                    sx={{
                                        borderRadius: 1,
                                        height: 36,
                                        '& .MuiInputBase-input': {
                                            fontSize: 14,
                                            padding: "8px 12px",
                                        },
                                    }}
                                />


                            </FormControl>
                            {moduleNameError && (
                                <FormHelperText error>{moduleNameError}</FormHelperText>
                            )}
                        </Box>


                        <Grid item xs={12} sm={12} sx={{paddingRight: '18px' }}>
                            <FormControl fullWidth sx={{mt:2}}>
                            <InputLabel id="passage-label" >Passage *</InputLabel>
                                <Select
                                    multiple
                                    name="passage"
                                    labelId="passage-label"
                                    id="passage"
                                    value={passage || []}
                                    onChange={(e) => {
                                        const selectedIds = e.target.value;
                                        const validSelectedIds = selectedIds.filter((id) =>
                                            passageList.some((p) => p.id === id)
                                        );
                                        setPassage(validSelectedIds);
                                        setPassageError('');
                                    }}
                                    renderValue={(selected) => (
                                        <div
                                            style={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: "4px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {passageList
                                                .filter((p) => selected.includes(p.id))
                                                .map((p) => (
                                                    <Tooltip
                                                        key={p.id}
                                                        title={
                                                            <div
                                                                dangerouslySetInnerHTML={{ __html: p.passage_text }}
                                                                style={{ maxWidth: "500px", whiteSpace: "normal" }}
                                                            />
                                                        }
                                                        placement="top"
                                                        arrow
                                                    >
                                                        <div
                                                            style={{
                                                                background: "#f1f1f1",
                                                                borderRadius: "8px",
                                                                padding: "2px 8px",
                                                                maxWidth: "180px",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        p.passage_text.length > 30
                                                                            ? `${p.passage_text.slice(0, 30)}...`
                                                                            : p.passage_text,
                                                                }}
                                                            />
                                                        </div>
                                                    </Tooltip>
                                                ))}
                                        </div>
                                    )}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 350,
                                                width: '550px',
                                                maxWidth: '550px',
                                            },
                                        },
                                    }}
                                    sx={{ width: '100%' }}
                                >
                                    <MenuItem disableRipple disableTouchRipple>
                                        <TextField
                                            autoFocus
                                            size="small"
                                            placeholder="Search passage..."
                                            fullWidth
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            onKeyDown={(e) => e.stopPropagation()}
                                        />
                                    </MenuItem>

                                    {filteredPassages.length > 0 ? (
                                            filteredPassages.filter(p => Array.isArray(p.questions) && p.questions.length > 0).map((p) => {
                                            const isAlreadySelected =
                                                selectedPassages.includes(p.id) && !passage.includes(p.id);

                                            return (
                                                <MenuItem
                                                    key={p.id}
                                                    value={p.id}
                                                    disabled={isAlreadySelected}
                                                    sx={{ opacity: isAlreadySelected ? 0.6 : 1 }}
                                                >
                                                    <Checkbox checked={passage?.includes(p.id)} />
                                                    <Tooltip
                                                        title={
                                                            <div
                                                                dangerouslySetInnerHTML={{ __html: p.passage_text }}
                                                                style={{ maxWidth: '500px', whiteSpace: 'normal' }}
                                                            />
                                                        }
                                                        placement="top"
                                                        arrow
                                                    >
                                                        <div
                                                            style={{
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: '400px',
                                                            }}
                                                        >
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    __html: (() => {
                                                                        if (isAlreadySelected)
                                                                            return `${p.passage_text.slice(0, 30)}... (Already Selected)`;
                                                                        if (p.passage_text.length > 30)
                                                                            return `${p.passage_text.slice(0, 30)}...`;
                                                                        return p.passage_text;
                                                                    })(),
                                                                }}
                                                            />
                                                        </div>
                                                    </Tooltip>
                                                </MenuItem>
                                            );
                                        })
                                    ) : (
                                        <MenuItem disabled>
                                            <em>No passages available</em>
                                        </MenuItem>
                                    )}
                                </Select>

                                {passageError && (
                                    <FormHelperText error>{passageError}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                    </DialogContent>

                    <DialogActions>
                        <Button id='modulepopSubmits' onClick={handleModuleSubmitCreate} color="secondary">
                            Submit
                        </Button>
                        <Button id='modulepopCancel' onClick={handleClose} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>


                </Dialog>


                <Dialog open={openPassageDialog} onClose={handleClosePassageDialog} fullWidth>
                    <DialogTitle>Edit Passages</DialogTitle>
                    <DialogContent>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                inputProps={{ maxLength: 50 }}
                                fullWidth
                                id="addname"
                                label="Module Name *"
                                type="search"
                                value={moduleName}
                                onChange={handleModuleNameChange}
                                sx={{
                                    mt: 2, mb: 1,
                                    borderRadius: 1,
                                    height: 36,
                                    '& .MuiInputBase-input': {
                                        fontSize: 14,
                                        padding: "8px 12px",
                                    },

                                }}
                            />
                            {moduleNameError && (
                                <FormHelperText sx={{ mb: 2 }} error>{moduleNameError}</FormHelperText>
                            )}
                            <FormControl fullWidth sx={{mt:2}}>
                            <InputLabel id="passage-label" >Passage *</InputLabel>
                            <Select
                                multiple
                                labelId="edit-passage-label"
                                id="edit-passage"
                                value={passage || []}
                                onChange={(e) => {
                                    const selectedIds = e.target.value;
                                    const validSelectedIds = selectedIds.filter((id) =>
                                        passageList.some((p) => p.id === id)
                                    );
                                    setPassage(validSelectedIds);
                                    setSelectedPassages((prev) => {
                                        const currentModuleUncheckedIds = passage.filter(id => !validSelectedIds.includes(id));
                                        return prev.filter(id => !currentModuleUncheckedIds.includes(id));
                                    });
                                }}
                                renderValue={(selected) => (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "4px",
                                            alignItems: "center",
                                        }}
                                    >
                                        {passageList
                                            .filter((p) => selected.includes(p.id))
                                            .map((p) => (
                                                <Tooltip
                                                    key={p.id}
                                                    title={
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: p.passage_text }}
                                                            style={{ maxWidth: "500px", whiteSpace: "normal" }}
                                                        />
                                                    }
                                                    placement="top"
                                                    arrow
                                                >
                                                    <div
                                                        style={{
                                                            background: "#f1f1f1",
                                                            borderRadius: "8px",
                                                            padding: "2px 8px",
                                                            maxWidth: "180px",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    p.passage_text.length > 30
                                                                        ? `${p.passage_text.slice(0, 30)}...`
                                                                        : p.passage_text,
                                                            }}
                                                        />
                                                    </div>
                                                </Tooltip>
                                            ))}
                                    </div>
                                )}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 350,
                                            width: "550px",
                                            maxWidth: "550px",
                                        },
                                    },
                                }}
                                sx={{ width: "100%" }}
                            >
                                <MenuItem disableRipple disableTouchRipple>
                                    <TextField
                                        autoFocus
                                        size="small"
                                        placeholder="Search passage..."
                                        fullWidth
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onKeyDown={(e) => e.stopPropagation()}
                                    />
                                </MenuItem>

                                    {filteredPassages.length > 0 ? (
                                        filteredPassages.filter(p => Array.isArray(p.questions) && p.questions.length > 0).map((p) => {
                                        const isAlreadySelectedElsewhere = selectedPassages.includes(p.id);
                                        const isSelectedInCurrentModule = (passage || []).includes(p.id);
                                        const isDisabled = isAlreadySelectedElsewhere && !isSelectedInCurrentModule;

                                        return (
                                            <MenuItem
                                                key={p.id}
                                                value={p.id}
                                                disabled={isDisabled}
                                                sx={{ opacity: isDisabled ? 0.6 : 1 }}
                                            >
                                                <Checkbox checked={passage?.includes(p.id)} />

                                                <Tooltip
                                                    title={
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: p.passage_text }}
                                                            style={{ maxWidth: "500px", whiteSpace: "normal" }}
                                                        />
                                                    }
                                                    placement="top"
                                                    arrow
                                                >
                                                    <div
                                                        style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            maxWidth: "400px",
                                                        }}
                                                    >
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    isDisabled
                                                                        ? `${p.passage_text.slice(0, 30)}... (Already Selected)`
                                                                        : p.passage_text.length > 30
                                                                            ? `${p.passage_text.slice(0, 30)}...`
                                                                            : p.passage_text,
                                                            }}
                                                        />
                                                    </div>
                                                </Tooltip>
                                            </MenuItem>
                                        );
                                    })
                                ) : (
                                    <MenuItem disabled>
                                        <em>No passages found</em>
                                    </MenuItem>
                                )}
                            </Select>
                            </FormControl>

                        </FormControl>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleUpdatePassages} color="secondary">
                            Update
                        </Button>
                        <Button onClick={handleClosePassageDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={editDialog} onClose={handleCloseEdit} fullWidth>
                    <DialogTitle>Edit Module</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    readOnly={submitted}
                                    variant="outlined"
                                    fullWidth
                                    id="addname"
                                    label="Module Name"
                                    type="text"
                                    name="name"
                                    value={editData.name || ""}
                                    onChange={EditModule}
                                    sx={{
                                        // bgcolor: "#f0f0f0",
                                        borderRadius: 1,
                                        marginBottom: '24px',
                                        height: 36,
                                        '& .MuiInputBase-input': {
                                            fontSize: 14,
                                            padding: "8px 12px",
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    readOnly={submitted}
                                    variant="outlined"
                                    fullWidth
                                    id="addweight"
                                    label="Module Weight"
                                    type="text"
                                    name="weightage"
                                    value={editData.weightage || ""}
                                    onChange={EditModule}
                                    sx={{ marginBottom: '20px', borderRadius: 1, height: 36, '& .MuiInputBase-input': { fontSize: 14, padding: "8px 12px", } }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleModuleUpdateQuestion} color="secondary">
                            Update
                        </Button>
                        <Button onClick={handleCloseEdit} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>


               <Dialog open={Preview} onClose={handlePreview} fullWidth>
  <DialogTitle>Preview</DialogTitle>

  <DialogContent style={{ marginLeft: "18px" }}>
    <ol type="1" style={{ paddingLeft: "2em", margin: 0 }}>
      {previewData ? (
        previewData?.passages?.length > 0 ? (
          previewData?.passages?.map((details, index) => {
            return (
              <li key={index}>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "10px",
                    gap: "10px",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                      flex: 1,
                    }}
                  >
                    <Typography
                      style={{
                        lineHeight: "1.2",
                        fontSize: "15px",
                        fontWeight: "500",
                        minWidth: "22px",
                      }}
                    >
                      {index + 1}.
                    </Typography>

                    <Typography
                      dangerouslySetInnerHTML={{ __html: details?.passage_text }}
                      variant="para"
                      style={{
                        lineHeight: "1.2",
                        fontSize: "15px",
                        fontWeight: "400",
                        paddingRight: "15px",
                      }}
                    />
                  </Box>
                </Box>
              </li>
            );
          })
        ) : (
          <div style={{ textAlign: "center", margin: "20px 0" }}>
            <CircularProgress />
          </div>
        )
      ) : null}

      {previewData && previewData?.questions_list?.length === 0 && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Typography
            variant="para"
            style={{
              lineHeight: "1.2",
              fontSize: "15px",
              fontWeight: "400",
              paddingRight: "15px",
              display: "inline-block",
            }}
          >
            No Questions Found
          </Typography>
        </div>
      )}
    </ol>
  </DialogContent>

  <DialogActions>
    <Button id="valCancel" onClick={handlePreview} color="primary">
      Cancel
    </Button>
    <Button id="updateVal" onClick={() => handleUpdateQuestions(editIndexnew)} color="primary">
      Update
    </Button>
  </DialogActions>
</Dialog>
                <Dialog open={deleteOpen} onClose={handleDeleteClose} fullWidth>
                                    <DialogContent className='GACognitivesection' sx={{ paddingTop: '25px !important' }}>
                                        <Typography> Do you want to delete this module ?</Typography>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button id='modulepopSubmits' onClick={DeleteModules} color="secondary">
                                            ok
                                        </Button>
                                        <Button id='modulepopCancel' onClick={handleDeleteClose} color="primary">
                                            Cancel
                                        </Button>
                                    </DialogActions>
                
                
                                </Dialog>
                <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
            </Page>
        </>
    );

}

const useStyles = makeStyles(() => ({
    imgPreviewRoot: {
        borderRadius: '10px',
        padding: '0.8rem;',
    },
    fileImgSIze: {
        width: '100%',
        height: '120px',
        objectFit: 'cover',
        objectPosition: 'center',
        border: '1px solid #fff',
        borderRadius: '5px',
        boxShadow: '0 3px 10px rgb(0 0 0 / 20%)',
    },
    badgeAlign: {
        boxShadow: '0 2px 8px -5px #ff0000',
        color: '#FF0000',
        fontSize: '1.2rem',
        backgroundColor: '#fff',
        padding: '2px',
        borderRadius: '10px',
        cursor: 'pointer',
    },
    deleteLabel: {
        width: 'max-content',
        cursor: 'pointer',
    }
}));

export default AddClat;